export default __webpack_public_path__ + "static/greenlight-e2d1a7720a293bd28cec4d2b9d41a7bd.ico";